import script from "./NonCurrentLiabilities.vue?vue&type=script&setup=true&lang=js"
export * from "./NonCurrentLiabilities.vue?vue&type=script&setup=true&lang=js"

import "./NonCurrentLiabilities.vue?vue&type=style&index=0&id=156a15e9&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-156a15e9"]])

export default __exports__